export const AWARD_TABLE_PROPERTIES = {
    HEADERS: ['AWARD NAME', 'AWARD DATE', 'AWARD PRIZE'],
    NO_SORT: [2],
    COLUMN_WIDTH: ['25%', '25%', '25%', '25%'],
    SORT_KEY: ['name', 'awardDate', ''],
};
